/**
 * 文件简介：统一前端日志工具
 * - 默认仅输出 warn / error；debug / info 需开启 VUE_APP_DEBUG 或 localStorage yuanqi_debug=1
 * - 现场调试：localStorage.setItem('yuanqi_debug', '1') 后刷新页面
 */

function isDebugEnabled() {
  if (process.env.VUE_APP_DEBUG === 'true') {
    return true
  }
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      return window.localStorage.getItem('yuanqi_debug') === '1'
    } catch (e) {
      return false
    }
  }
  return false
}

function debugLog(level, args) {
  if (!isDebugEnabled()) {
    return
  }
  const fn = level === 'info' ? console.info : console.log
  fn.apply(console, args)
}

export const logger = {
  debug: (...args) => debugLog('debug', args),
  info: (...args) => debugLog('info', args),
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
}

export default logger
